(function () {
  function getActiveTabPanel(guide) {
    return guide.querySelector('.size-guide__panel.is-active') || guide.querySelector('.size-guide__panel') || guide;
  }

  function setActiveUnitUI(guide, unit) {
    guide.setAttribute('data-active-unit', unit);

    guide.querySelectorAll('[data-size-unit-option]').forEach(function (option) {
      var isActive = option.getAttribute('data-size-unit-option') === unit;
      option.classList.toggle('is-active', isActive);
    });

    var toggle = guide.querySelector('[data-size-unit-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-label', unit === 'cm' ? 'Current unit CM, switch measurement unit' : 'Current unit IN, switch measurement unit');
    }
  }

  function applyUnit(guide, requestedUnit) {
    var activePanel = getActiveTabPanel(guide);
    var unitPanels = activePanel.querySelectorAll('[data-size-unit-panel]');

    if (!unitPanels.length) {
      setActiveUnitUI(guide, requestedUnit || guide.getAttribute('data-active-unit') || 'cm');
      return;
    }

    var targetUnit = requestedUnit || guide.getAttribute('data-active-unit') || 'cm';
    var hasTarget = false;

    unitPanels.forEach(function (panel) {
      if (panel.getAttribute('data-size-unit-panel') === targetUnit) {
        hasTarget = true;
      }
    });

    if (!hasTarget) {
      targetUnit = unitPanels[0].getAttribute('data-size-unit-panel') || targetUnit;
    }

    unitPanels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-size-unit-panel') === targetUnit;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    setActiveUnitUI(guide, targetUnit);
  }

  function applyTab(guide, targetTab) {
    var tabButtons = guide.querySelectorAll('[data-size-tab-button]');
    var tabPanels = guide.querySelectorAll('[data-size-tab-panel]');

    if (!tabPanels.length) return;

    var hasTarget = false;

    tabPanels.forEach(function (panel) {
      if (panel.getAttribute('data-size-tab-panel') === targetTab) {
        hasTarget = true;
      }
    });

    if (!hasTarget && tabButtons[0]) {
      targetTab = tabButtons[0].getAttribute('data-size-tab-button');
    }

    tabButtons.forEach(function (button) {
      var isActive = button.getAttribute('data-size-tab-button') === targetTab;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    tabPanels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-size-tab-panel') === targetTab;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    applyUnit(guide, guide.getAttribute('data-active-unit') || 'cm');
  }

  function initSizeGuide(guide) {
    if (!guide || guide.dataset.sizeGuideInitialized === 'true') return;

    guide.dataset.sizeGuideInitialized = 'true';

    var initialUnit = guide.getAttribute('data-active-unit') || 'cm';
    var activeTabButton = guide.querySelector('[data-size-tab-button].is-active') || guide.querySelector('[data-size-tab-button]');
    var activeTab = activeTabButton ? activeTabButton.getAttribute('data-size-tab-button') : '';

    guide.querySelectorAll('[data-size-tab-button]').forEach(function (button) {
      button.setAttribute('role', 'tab');

      button.addEventListener('click', function () {
        var targetTab = button.getAttribute('data-size-tab-button');
        if (targetTab) {
          applyTab(guide, targetTab);
        }
      });
    });

    guide.querySelectorAll('[data-size-tab-panel]').forEach(function (panel) {
      panel.setAttribute('role', 'tabpanel');
    });

    var unitToggle = guide.querySelector('[data-size-unit-toggle]');

    if (unitToggle) {
      unitToggle.addEventListener('click', function (event) {
        var option = event.target.closest('[data-size-unit-option]');
        var currentUnit = guide.getAttribute('data-active-unit') || 'cm';
        var targetUnit = option ? option.getAttribute('data-size-unit-option') : currentUnit === 'cm' ? 'in' : 'cm';

        if (targetUnit) {
          applyUnit(guide, targetUnit);
        }
      });
    }

    if (activeTab) {
      applyTab(guide, activeTab);
    } else {
      applyUnit(guide, initialUnit);
    }
  }

  function initAllSizeGuides() {
    document.querySelectorAll('[data-size-guide]').forEach(initSizeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSizeGuides);
  } else {
    initAllSizeGuides();
  }

  document.addEventListener('shopify:section:load', initAllSizeGuides);
})();